export const DASH = '—';

export const fmt = (n) => (n == null || n === '' || Number.isNaN(Number(n)) ? DASH : Math.round(Number(n)).toLocaleString('en-IN'));

export const fmtDecimal = (n, digits = 1) => (n == null || n === '' || Number.isNaN(Number(n))
  ? DASH
  : Number(n).toLocaleString('en-IN', { minimumFractionDigits: digits, maximumFractionDigits: digits }));

export const fmtDate = (value) => {
  if (!value) return DASH;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? DASH : d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

export const titleCase = (s) => (s ? String(s).replace(/\b\w/g, (c) => c.toUpperCase()) : '');

export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export const orDash = (v) => (v == null || v === '' ? DASH : v);

export const initials = (name) => String(name || '').split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('') || DASH;

export const errorMessage = (err, fallback) => {
  const status = err?.response?.status;
  if (status === 403) return 'The CSR Impact dashboard is available for CSR and NGO partners only.';
  if (status === 404) return 'This record could not be found.';
  return err?.response?.data?.message || fallback;
};
